export default __webpack_public_path__ + "static/media/alloydb.8af634bc.svg";